module.exports = new __parcel__URL__("killshot.37187ef2.png").toString();